import { render, staticRenderFns } from "./CommunityNewDMChatModal.vue?vue&type=template&id=31731b18&scoped=true&"
import script from "./CommunityNewDMChatModal.vue?vue&type=script&lang=js&"
export * from "./CommunityNewDMChatModal.vue?vue&type=script&lang=js&"
import style0 from "./CommunityNewDMChatModal.vue?vue&type=style&index=0&id=31731b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31731b18",
  null
  
)

export default component.exports